angular.module('elfium').directive('elfiumSort', ['elfiumUrlService', 
  function (elfiumUrlService) {
    return {
      restriction: 'A',
      transclude: true,
      scope: {
        currentSort: '=',
        elfiumSort: '@',
        comparator: '&?'
      },
      controller: 'elfiumSortController',
      templateUrl: elfiumUrlService.getTemplateUrl('elfium', 'elfiumSort')
    }
  }
]);


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumSort.ts